<template>
    <!--
    Main header component, displaying the page main headline and actions
    -->
    <header class="main-header">
        <a href="#" @click.prevent="$store.dispatch('layout/toggleNavigation')" v-if="viewport == 'ml' || viewport == 'mp'">
            <icon name="menu" viewBox="0 0 24 24" />
        </a>

        <slot />

    </header>
</template>

<script>
import { mapState } from 'vuex';

export default
{
    name: 'MainHeader',

    computed:
    {
        ...mapState({
            viewport: ({ layout }) => layout.viewport,
        })
    },
}
</script>



// WEBPACK FOOTER //
// MainHeader.vue?11b2d396